import { Component, OnChanges } from '@angular/core';
import { CustomerManageService } from '../shared/customer-manage.service';
import { BaseComponent } from '../../shared/base-components/base.component';
import { CustomerIndividualBiometric } from '../models/customer-individual-biometric.model';
import { EyeColorType } from '../models/enums/eye-color-type.enum';
import { HairColorType } from '../models/enums/hair-color-type.enum';
import { GenderType } from '../models/enums/gender-type.enum';

@Component({
    selector: 'historical-customer-attributes',
    templateUrl: './historical-customer-attributes.html',
    inputs: ['customerNumberId']
})

export class HistoricalCustomerAttributesComponent extends BaseComponent implements OnChanges {
    public attributes: CustomerIndividualBiometric[];
    public customerNumberId: number;

    private eyeColorTypes: EyeColorType = new EyeColorType();
    private hairColorTypes: HairColorType = new HairColorType();
    private genderTypes: GenderType = new GenderType();

    constructor(private customerService: CustomerManageService) {
        super();
    }

    ngOnInit() {
    }

    ngOnChanges() {
        if (this.attributes !== undefined) {
            this.denormalizeData();
        } else if (this.customerNumberId != null) {
            this.populateHistoricalCertifications(this.customerNumberId);
        }
    }

    populateHistoricalCertifications(customerNumberId: number) {
        var self = this;

        this.customerService.getHistoricalCustomerAttributes(customerNumberId)
            .subscribe(result => {
                this.attributes = result;
            },
            e => {
                this.attributes = [];
                console.log('error', e);
            },
            () => {
                this.denormalizeData();
            });
    }

    denormalizeData() {
        for (const attr of this.attributes) {
            let feet = '';
            let inches = '';

            if (attr.height != null) {
                feet += Math.floor(attr.height / 12).toString() + ' FT';

                if ((attr.height % 12) > 0) {
                    inches += ' ' + (attr.height % 12).toString() + ' IN';
                }
            }

            attr.displayHeight = feet + inches;
            attr.displayWeight = attr.weight != null ? attr.weight.toString() + ' LBS' : '';
            attr.eyeColor = this.getValues(attr.eyeColorTypeId, this.eyeColorTypes);
            attr.hairColor = this.getValues(attr.hairColorTypeId, this.hairColorTypes);
            attr.gender = this.getValues(attr.genderTypeId, this.genderTypes);
        }
    }

    getValues(id: number, types: any): string {
        if (id !== undefined && id !== null) {
            return types.FromId(id).displayValue;
        } else {
            return '';
        }
    }
}
